import axiosInstance from './axios';

/**
 * Editable content of the storefront's "static" pages (À propos, B2B).
 * The whole page document travels as one JSON blob.
 */
export const pageContentService = {
  get: async (key) => {
    const response = await axiosInstance.get(`/page-contents/${key}`);
    return response.data;
  },

  update: async (key, content) => {
    const response = await axiosInstance.put(`/page-contents/${key}`, { content });
    return response.data;
  },

  reset: async (key) => {
    const response = await axiosInstance.post(`/page-contents/${key}/reset`);
    return response.data;
  },
};
